import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { GetStartedPage } from 'features/getStarted'
import { canViewAnalyticsPermission, canViewConfigurationPermission } from 'hooks/usePermission'
import { z } from 'zod/v4'

export const getStartedSearchSchema = z.object({
  library: z.string().optional(),
})

export type GetStartedSearch = z.infer<typeof getStartedSearchSchema>

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/get-started/')({
  component: GetStartedPage,
  validateSearch: getStartedSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Get Started'),
      },
    ],
  }),
  beforeLoad: async (ctx) => {
    await protectWithWorkspacePermissions(canViewAnalyticsPermission)(ctx)
    await protectWithWorkspacePermissions(canViewConfigurationPermission)(ctx)
  },
})
